import React, { useContext } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import CategoryChip from './CategoryChip';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { AppContext } from '../../../context/appContext';

const CategoryFilter = ({
  categoryList,
  activeFilter,
  activateFilter,
  handleChange,
  value
}) => {
  const { width } = useWindowDimensions();
  const [settings] = useContext(AppContext);

  const showCategoryPicker = () => {
    if (width > 1100) {
      return (
        <>
          {categoryList.map(category => (
            <CategoryChip
              key={category.name}
              title={category.name}
              id={category.id}
              activeFilter={activeFilter}
              activate={activateFilter}
            />
          ))}
          <CategoryChip
            title="Minden termék"
            id={0}
            activeFilter={activeFilter}
            activate={activateFilter}
          />
        </>
      );
    }

    return (
      <Select
        onChange={e => activateFilter(Number(e.target.value))}
        bgcolor={settings?.categoryBg || '#ffe0a2'}
        color={settings?.categoryColor || 'black'}
      >
        {categoryList.map(category => (
          <option key={category.name} value={category.id}>
            {category.name}
          </option>
        ))}
        <option value={0}>Minden termék</option>
      </Select>
    );
  };
  return (
    <Root width={width}>
      <SearchInput
        bgcolor={settings?.categoryBg || '#ffe0a2'}
        color={settings?.categoryColor || 'black'}
      >
        <FontAwesomeIcon icon={faSearch} />
        <input
          placeholder="Termék kereső"
          onChange={e => handleChange(e.target.value)}
          value={value}
        />
      </SearchInput>
      {categoryList.length > 0 && showCategoryPicker()}
    </Root>
  );
};

export default CategoryFilter;

CategoryFilter.propTypes = {
  categoryList: PropTypes.arrayOf().isRequired,
  activeFilter: PropTypes.number.isRequired,
  activateFilter: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: ${props => (props.width > 1100 ? '80%' : '100%')};
  margin-bottom: 32px;
`;

const SearchInput = styled.div`
  background-color: ${props => props.bgcolor};
  border-width: 0px 0px 0px 0px;
  border-radius: 25px 25px 25px 25px;
  padding: 0.75em;
  font-size: 1em;
  box-sizing: border-box;
  transition: all 0.1s linear;
  margin: 0 16px;
  display: inline-flex;
  align-items: center;
  width: 20%;
  max-width: 300px;
  min-width: 200px;

  @media (max-width: 1100px) {
    width: 300px;
  }

  & input {
    margin-left: 16px;
    background: none;
    border: none;
    height: 100%;
    width: 100%;
    font-size: 1em;
    font-family: inherit;
    color: ${props => props.color};

    &:focus {
      outline: none;
    }
  }
`;

const Select = styled.select`
  /* styling */
  background-color: white;
  border: thin solid blue;
  border-radius: 25px 25px 25px 25px;
  display: inline-block;
  font: inherit;
  font-size: 100%;
  width: 100%;
  max-width: 300px;
  margin: 8px;

  /* reset */

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, black 50%),
    linear-gradient(135deg, black 50%, transparent 50%),
    linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  background-position: calc(100% - 20px) calc(20px + 2px),
    calc(100% - 15px) calc(20px + 2px), calc(100% - 2.5em) 1.25em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  background-color: ${props => props.bgcolor};
  color: ${props => props.color};
  border-width: 0px;
  border-radius: 25px 25px 25px 25px;
  padding: 12px 32px 12px 12px;
  font-size: 1em;
  box-sizing: border-box;
  transition: all 0.1s linear;

  & option {
    color: ${props => props.color};
  }

  &#date {
    width: 100%;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  }
`;
